import {
  trans,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
  SUNDAY,
} from '@helpers/translator'

export const useDayTranslations = () => {
  // Clés des jours en anglais alignées avec Date.getDay()
  const daysOfWeekKeys = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ]

  // Traductions des jours alignées avec Date.getDay()
  const daysOfWeekTranslations = [
    trans(MONDAY),
    trans(TUESDAY),
    trans(WEDNESDAY),
    trans(THURSDAY),
    trans(FRIDAY),
    trans(SATURDAY),
    trans(SUNDAY),
  ]

  return { daysOfWeekKeys, daysOfWeekTranslations }
}
